export default __webpack_public_path__ + "static/media/Chatbot.568bef3e.png";